// AUTO-GENERATED from services/app-api-service/codeigniter/application/contracts/Chamados_ConfigLogoUploadInput.php
// Do not edit by hand — edit the PHP InputContract and the sync hook will regenerate this file.
// Bulk regeneration: scripts/sync-contracts/sync-all.sh

/**
 * InputContract de POST /chamados/config/logo — subir o logo do cabeçalho do
 * e-mail de aviso. Mesmo formato de `Chamados_AnexarInput` (multipart), sem
 * `chamado_id`/`mensagem_id`: este arquivo não pertence a um chamado, é
 * configuração do processo inteiro.
 */
import { registerContract } from './validate'

export interface Chamados_ConfigLogoUploadInput {
_files: unknown[]
}

registerContract('Chamados_ConfigLogoUploadInput', {
  _files: { type: 'array',   required: true },
})
